import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

function Login() {
  const [user, setUser] = useState('');
  const [pwd, setPwd] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const primary = '#9E1518';

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!user || !pwd) {
      alert('Por favor, preencha todos os campos.');
      return;
    }

    try {
      const response = await axios.post('http://api.sigmasystems.com.br/api/topdistribuidora/login', { user, pwd });

      if (response.status === 200 && response.data?.token) {
        localStorage.setItem('token', response.data.token);
        navigate('/dashboard');
      } else {
        alert('Usuário ou senha inválido!');
      }
    } catch (error) {
      console.error('Erro no login:', error);
      alert('Usuário ou senha inválido!');
    }
  };

  return (
    <div className="bg-login">
      <div className="loginContainer">
        <div className="loginContent">
          <img className="logoLogin" src="/images/toplogo.png" alt="Logo Top Distribuidora" />
          <form className="formLogin" onSubmit={handleLogin}>
            <TextField 
              id="outlined-user"
              label="Usuário" 
              variant="outlined"
              sx={{ width: 300, backgroundColor: '#fff', borderRadius: 1 }}
              color="error"
              value={user}
              onChange={(e) => setUser(e.target.value)}
            />
            <FormControl 
              sx={{ width: 300, marginTop: 1, backgroundColor: '#fff', borderRadius: 1 }}
              color="error"
              variant="outlined"
            >
              <InputLabel htmlFor="outlined-password">Senha</InputLabel>
              <OutlinedInput
                id="outlined-password"
                type={showPassword ? 'text' : 'password'}
                value={pwd}
                onChange={(e) => setPwd(e.target.value)}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Senha"
              />
            </FormControl>
            <Button 
              type="submit"
              variant="contained"
              sx={{
                backgroundColor: primary,
                width: 300,
                height: 56,
                fontFamily: 'Montserrat',
                fontSize: 18,
                marginTop: 2,
                '&:hover': { backgroundColor: primary },
              }}
            >
              Entrar
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
